import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface PostClosingNumberModalProps {
  title: string;
  fieldKey: string;
  loans: any[];
  onConfirm: (value: number) => void;
  onClose: () => void;
  options?: {
    onlyInteger?: boolean;
  };
}

export const PostClosingNumberModal: React.FC<PostClosingNumberModalProps> = ({
  title,
  loans,
  onConfirm,
  onClose,
  options = {},
}) => {
  const [value, setValue] = useState<string>('');

  const isValid = (): boolean => {
    if (options.onlyInteger) {
      return /^-?\d+$/.test(value.trim());
    }
    return /^-?\d+(\.\d+)?$/.test(value.trim());
  };

  const handleConfirm = () => {
    if (isValid()) {
      onConfirm(parseInt(value, 10));
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box mb={3}>
          <TextField
            label="Enter Number"
            variant="outlined"
            fullWidth
            value={value}
            onChange={e => {
              const input = e.target.value;
              if (options.onlyInteger) {
                if (/^-?\d*$/.test(input)) {
                  setValue(input);
                }
              } else {
                if (/^-?\d*\.?\d*$/.test(input)) {
                  setValue(input);
                }
              }
            }}
          />
        </Box>

        <Box>
          <Typography variant="subtitle1">Loans to update:</Typography>
          <List dense>
            {loans.map((loan, index) => (
              <ListItem key={index} divider>
                <ListItemText primary={`Loan ID: ${loan}`} />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={!isValid()}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};